export default __webpack_public_path__ + "static/media/vantage_logo_new.a0e77eab.png";